<template>
  <v-dialog
    v-model="show"
    persistent
    width="350"
  >
    <v-card>
      <v-card-title
        class="title"
      >
        申し込みが完了しました
      </v-card-title>

      <v-card-text class="mt-10 text">
        発注番号は{{requestCode}}です。
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-1"
          dark
          text
          to="/teacher/home"
        >
          ホーム画面へ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    show: false,
  }),

  methods: {
    open() {
      this.show = true;
    },

    close() {
      this.show = false;
    }
  },

  computed: {
    requestCode() {
      return this.$store.state.sheet.requestCode
    }
  }
}
</script>

<style lang="stylus" scoped>
.title
  justify-content center
  background-image linear-gradient(to right, #2465a2, #3d79a8, #1d73aa)
  color white

.text
  justify-content center
  font-size 16px
  font-weight bold
</style>
